import { useState } from "react";
import { useDispatch } from "react-redux";
import { addPassword } from "../../REDUX/Slices/users.Slice";
import {validateAdminPassword} from "./../../REDUX/Models/admin.Model";
import { Link, useNavigate } from "react-router-dom";
import Logo from "./../../assets/Logo.svg";
import "./index.scss";

export default function Admin() {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setPassword(e.target.value);
    if (error) setError("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!password.trim()) {
      setError("برجاء إدخال كلمة المرور");
      return;
    }

    try {
      const res = await validateAdminPassword(password);
      const { role } = res.data;

      if (!role) {
        setError("لا يوجد صفحة مخصصة لهذا الرابط");
        return;
      }

      dispatch(addPassword({ password }));
      navigate(role);
    } catch {
      setError("كلمة المرور غير صحيحة");
    }
  };

  return (
    <div className="admin">
      <div className="container">
        <div className="row">
          <div className="password">
            <Link to="/">
              <img src={Logo} alt="Twrny Logo" />
            </Link>
            <form onSubmit={handleSubmit}>
              <label onClick={togglePasswordVisibility}>
                <i className={showPassword ? "fa-solid fa-lock-open" : "fa-solid fa-lock"}></i>
              </label>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="كلمة السر"
                value={password}
                onChange={handleChange}
                required
              />
              <button type="submit">دخول</button>
              {error && <p className="error">{error}</p>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
